<template>
  <div class="h-dvh max-h-dvh">
    <slot />
  </div>
</template>
